<template>
  <div v-if="companyBaseInfo && pageData" class="company-detail">
    <Header :webpageSetting="pageData" :isMSDCustom="isMSDCustom" :companyBaseInfo="companyBaseInfo" :isPreview="isPreview" :activePage="activePage" :showMenu.sync="showMenu" :personalAgreementStatus="personalAgreementStatus" :surveyInfo="surveyInfo"/>
    <CustomContent :customContentList="pageData?.webpageItems" :showGap="pageData.showGap" />
    <div v-if="!hasHiddenPoweredWord" class="powered-by">Powered by ajinga.com</div>
    <Footer v-if="footerData" :isMSDCustom="isMSDCustom" :activePage="activePage" :isPreview="isPreview" :data="footerData" :company="companyBaseInfo.company"></Footer>
    <VideoNavigation
      v-if="pageData.video_navigation?.video_list?.length > 0"
      class="video-navigation"
      :class="showChatBot && 'has-chatbot'"
      :data="pageData.video_navigation.video_list"
      @videoNavigationShowChange="onVideoNavigationShowChange"
    />
  </div>
</template>

<script>
import Header from './header.vue'
import CustomContent from './customContent.vue'
import Footer from './footer.vue'
import VideoNavigation from '@/components/videoNavigation/videoNavigation.vue'

export default {
  components: {
    Header,
    CustomContent,
    Footer,
    VideoNavigation
  },
  props: {
    isMSDCustom: {
      type: Boolean,
      default: false
    },
    pageData: {
      required: true
    },
    footerData: {
      required: true
    },
    companyBaseInfo: {
      required: true
    },
    activePage: {
      type: String
    },
    videoList: {
      type: Array
    },
    isPreview: {
      required: false,
      type: Boolean
    },
    showChatBot: {
      required: false,
      type: Boolean
    },
    personalAgreementStatus: {
      default: null
    },
    surveyInfo: {
      default: () => { }
    }
  },
  data () {
    return {
      showMenu: false
    }
  },
  computed: {
    pageNum () {
      return this.$route.query.page_num
    },
    hasVideoNavigationPermission () {
      return this.hasAnyPermission('PREMIUM_VIDEO_NAVIGATION')
    },
    hasHiddenPoweredWord () {
      return this.hasAnyPermission('PREMIUM_HIDDEN_WEB_PAGE_BOTTOM_STATEMENT') || this.companyBaseInfo.has_hidden_web_page_bottom_statement_premium
    }
  },
  created () {
  },
  methods: {
    onVideoNavigationShowChange (value) {
      this.$emit('videoNavigationShowChange', value)
    }
  }
}
</script>
<style lang="scss" scoped>
.company-detail{
  background-color: #f7f7f7;

  .powered-by {
    text-align: center;
    font-size: 12px;
    background-color: #fff;
    padding: 15px 0;

    .company-icon {
      margin: 0 5px;
      width: 18px;
      height: 13px;
      background: url($baseDomain + 'static/image/mobile_web/icon_ajinga.png');
      background-size: 100% 100%;
      display: inline-block;
      vertical-align: middle;
    }
  }

  .video-navigation {
    &.has-chatbot {
      margin-right: 95px;
    }
  }
}

</style>
